export const message = {
  updateUserSettingsSuccess: 'User settings successfully updated',
}